interface ShouldShowEarnWalletLinkArgs {
  objective?: string | null;
  availableCents?: number | null;
}

export function shouldShowEarnWalletLink({
  objective,
}: ShouldShowEarnWalletLinkArgs): boolean {
  return objective === "other_channels" || objective === "own_brand";
}
